import * as React from 'react';
import { bindActionCreators } from 'redux';
import { connect, Dispatch } from 'react-redux';
import { capitalize } from 'lodash';
import cx from 'classnames';

import Checkbox from 'components/Checkbox';
// @ts-ignore
import { DisabledTooltipLayer } from './SelectFromList';
import EventTracking from 'lib/EventTracking';
import MediaObject from 'components/MediaObject';
// @ts-ignore
import { selectRecipient } from 'reducers/roleBasedMessagingSearch';
import Text from 'components/Text';
import UserAvatar from 'users/components/UserAvatar';
import { ComposerContext, UIEventContext } from './ComposerContext';
import { IndividualRecipient, MessageFilterType } from 'types/typescript/messagingTypes';

type Props = {
  recipient: IndividualRecipient;
  recipientIsSelected: boolean;
  disabledCopy?: React.ReactNode;
} & ReduxDispatchProps;

type ReduxDispatchProps = {
  onSelectRecipient: (recipient: IndividualRecipient, filter?: MessageFilterType) => void;
};

class IndividualRecipientItem extends React.Component<Props> {
  logSelectionEvent = (uiEventContext: UIEventContext) => {
    if (this.props.recipientIsSelected) {
      EventTracking.trackKey('announcements.share_to.individual.unselect.click', uiEventContext);
      return;
    }
    EventTracking.trackKey('announcements.share_to.individual.select.click', uiEventContext);
  };

  handleSelection = () => {
    this.props.onSelectRecipient(this.props.recipient, undefined);
  };

  render() {
    const { recipient, disabledCopy } = this.props;
    const { member } = recipient;
    const user = member.getUser();
    const memberName = member.getName();

    const component = (
      <ComposerContext.Consumer>
        {composerContext => (
          <li
            className={cx('RecipientItem', {
              'RecipientItem--disabled': !!disabledCopy,
            })}
            onClick={() => {
              this.handleSelection();
              this.logSelectionEvent(composerContext.getUIEventContext());
            }}>
            <MediaObject figure="right" center>
              <MediaObject gutter="small" center>
                <UserAvatar size="medium" user={user.toJSON()} />
                <div>
                  <Text size="small" element="div" truncate>
                    {memberName}
                  </Text>
                  <Text size="xsmall" element="div" color="eclipse">
                    {capitalize(member.getRole())}
                  </Text>
                </div>
              </MediaObject>
              <Checkbox onChange={this.handleSelection} checked={this.props.recipientIsSelected} />
            </MediaObject>
          </li>
        )}
      </ComposerContext.Consumer>
    );
    return disabledCopy ? (
      <DisabledTooltipLayer text={disabledCopy}>{component}</DisabledTooltipLayer>
    ) : (
      component
    );
  }
}

const mapDispatchToProps = (dispatch: Dispatch<any>): ReduxDispatchProps => {
  return bindActionCreators(
    {
      onSelectRecipient: selectRecipient,
    },
    dispatch
  );
};

export { IndividualRecipientItem };

export default connect(undefined, mapDispatchToProps)(IndividualRecipientItem);
